export default __webpack_public_path__ + "static/media/Promo03_Hotsale_Coche_330x330.e2ccacbf.png";